import React from 'react';

export interface SortableHeaderProps<K> {
  field: K;
  children: React.ReactNode;
  onSort: (field: K) => void;
  getSortIcon: (field: K) => React.ReactNode;
  className?: string;
}

export function SortableHeader<K>({
  field,
  children,
  onSort,
  getSortIcon,
  className = ""
}: SortableHeaderProps<K>) {
  return (
    <th
      className={`px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 transition-colors select-none ${className}`}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-1">
        {children}
        {getSortIcon(field)}
      </div>
    </th>
  );
}